<template>
  <div class="cardMain" ref="container">
    <SearchForm v-model="cardno" placeholder="请输入卡号/手机号"></SearchForm>
    <AddOperate @click="addCard"></AddOperate>

    <isEmpty v-if="cardList.length === 0">
      <div slot="desc" class="is-empty_desc">
        <div class="is-empty_desc-title">
          暂时没有IC卡
        </div>
        <div class="is-empty_descript">
          <p>请点击右侧 ’添加‘ 按钮</p>
          <p>开始您的运营之旅吧！</p>
        </div>
      </div>
    </isEmpty>
    <div class="content" v-else>
      <div class="content-title">
        全部卡<span>{{ total }}</span>
        <i class="el-icon-plus" @click="addCard"></i>
      </div>
      <mu-load-more @refresh="refresh" :refreshing="refreshing" :loaded-all="loaded_all" :loading="loading" @load="load">
        <div class="list-item" v-for="(item, index) in cardList" :key="`list-item_${index}`">
          <div class="header-info">
            <div class="no text-overflow">
              卡号：{{ item.cardNo }}
            </div>
            <div class="state" :class="{ 'finish': item.state === '正常' }">{{ item.state || "未知" }}</div>
          </div>
          <div class="data-box">
            <div class="data-item">
              <div class="before">用户手机号</div>
              <div class="after">{{ item.mobile || '暂无' }}</div>
            </div>
            <div class="data-item">
              <div class="before">卡余额</div>
              <div class="after">{{ handleControlNumber(item.sum || 0, 2) }}</div>
            </div>
            <div class="data-item">
              <div class="before">绑定日期</div>
              <div class="after">{{ item.createTime || '-' }}</div>
            </div>
          </div>
          <div class="options" :class="{ 'options-disiabled': (item.state === '挂失' || item.state === '未启用') }">

            <div class="more">
              <el-popover popper-class="site-custom" trigger="click"  placement="bottom-start">
                <div  class="tips-box">
                  <!--                  <div @click="edit(item)">编辑</div>-->
                  <div class="options-item" @click="handleGoToList(item.cardNo, 0)">充值记录</div>
                  <div class="options-item" @click="handleGoToList(item.cardNo, 1)">使用记录</div>
                  <div class="options-item" @click.stop="delCard(item)" v-if="item.state !== '已补卡'">删除</div>
                </div>
                <img class="icon"  slot="reference" src="@/assets/image/icon/more.png" alt="" />
              </el-popover>
            </div>

            <div class="options-item" @click="editCard(item)"  v-if="item.state !== '挂失' && item.state !== '已挂失' && 
            item.mobile == '' && item.state !== '已补卡'">
              编辑
            </div>
            
            <div class="options-item" @click="lossCard(item.cardNo, item.state)" v-if="item.state === '正常'">挂失</div>

            <div class="options-item" @click="chongzhi(item)" 
              v-if="item.state !== '挂失' && item.state !== '已挂失' && item.state !== '已补卡'">
              充值
            </div>

            <div class="options-item" v-if="item.state === '挂失'" @click="cancelLoss(item)">取消挂失</div>

            <div class="options-item" @click="replaceCardHandler(item)" v-if="item.state === '挂失'">补卡</div>

            <div class="options-item" @click.stop="delCard(item)" v-if="item.state == '已补卡'">删除</div>

          </div>

        </div>
      </mu-load-more>
    </div>

    <van-dialog @close="handleDialogVisible(false)" v-model="visible" :show-cancel-button="false"
      :show-confirm-button="false" width="6.8918rem" class="va-dialog">
      <template v-slot:title></template>
      <div class="dialog-content">
        <div class="title">挂失</div>
        <div class="content-box">
          <div class="desc">您是否确定要对该卡片进行挂失处理？
          </div>
          <div class="confirm" @click="handleClickLoss()">确认</div>
          <div class="text" @click="handleDialogVisible(false)">我再想想</div>
        </div>
      </div>
    </van-dialog>


    <van-dialog @close="deleteVisible=false" v-model="deleteVisible" :show-cancel-button="false"
      :show-confirm-button="false" width="6.8918rem" class="va-dialog">
      <template v-slot:title></template>
      <div class="dialog-content">
        <div class="title">删除</div>
        <div class="content-box">
          <div class="desc">您是否确定要对该卡片进行删除处理？
          </div>
          <div class="confirm" @click="delCardConfirm()">确认</div>
          <div class="text" @click="deleteVisible=false">我再想想</div>
        </div>
      </div>
    </van-dialog>


    <van-dialog @close="lossVisible=false" v-model="lossVisible" :show-cancel-button="false"
      :show-confirm-button="false" width="6.8918rem" class="va-dialog">
      <template v-slot:title></template>
      <div class="dialog-content">
        <div class="title">取消挂失</div>
        <div class="content-box">
          <div class="desc">您是否确定要对该卡片进行取消挂失处理？
          </div>
          <div class="confirm" @click="cancelLossConfirm()">确认</div>
          <div class="text" @click="lossVisible=false">我再想想</div>
        </div>
      </div>
    </van-dialog>


    <van-dialog @close="payVisible=false" v-model="payVisible" :show-cancel-button="false"
      :show-confirm-button="false" width="7.8918rem" class="va-dialog">
      <template v-slot:title></template>
      <div class="dialog-content">
        <div class="title">充值</div>

        <div class="dialog-item">
          <div class="item-title">卡号</div>
          <div class="item-value">{{curItem.cardNo}}</div>
        </div>

        <div class="dialog-item">
          <div class="item-title">余额</div>
          <div class="item-value">{{curItem.sum}}</div>
        </div>

        <div class="dialog-item">
          <div class="item-title">充值金额</div>
          <div>
            <el-input maxlength="6" type="text" v-model="amount" style="width: 150px"
            placeholder="请输入充值金额" clearable />
          </div>
        </div>

        <div class="content-box">
          <div class="confirm" @click="chongzhiConfirm()">确认</div>
          <div class="text" @click="payVisible=false">我再想想</div>
        </div>
      </div>
    </van-dialog>


    <van-dialog @close="replaceVisible=false" v-model="replaceVisible" :show-cancel-button="false"
      :show-confirm-button="false" width="7.8918rem" class="va-dialog">
      <template v-slot:title></template>
      <div class="dialog-content">
        <div class="title">补卡</div>

        <div class="dialog-item">
          <div class="item-title">卡号</div>
          <div class="item-value">{{curItem.cardNo}}</div>
        </div>

        <div class="dialog-item">
          <div class="item-title">余额</div>
          <div class="item-value">{{curItem.sum}}</div>
        </div>

        <div class="dialog-item">
          <div class="item-title">新卡号</div>
          <div>
            <el-input maxlength="16" type="text" v-model="newCardNo" style="width: 200px"
            placeholder="请输入新卡号" clearable />
          </div>
        </div>

        <div class="content-box">
          <div class="confirm" @click="replaceCardConfirm()">确认</div>
          <div class="text" @click="replaceVisible=false">我再想想</div>
        </div>
      </div>
    </van-dialog>


  </div>
</template>
<script>
import { getCardList, lossCard,  delCards, chongzhiCard, cancelLoss, cardFeplacement } from "@/api/newApi";
import { Toast } from "vant";
import "vant/lib/toast/style/index";
import { digitUtil } from "@/utils/utils";
import AddOperate from "@/components/add-operate/index.vue";

export default {
  data () {
    return {
      cardList: [],
      cardno: "",
      loading: false,
      refreshing: false,
      num: 1,
      loaded_all: false,
      pages: 0,
      total: 0,
      visible: false,
      cardNo: null,
      deleteVisible:false,
      payVisible:false,
      curItem:{},
      amount:'',
      lossVisible:false,
      replaceVisible:false,
      newCardNo:'',
    };
  },
  components: {
    AddOperate
  },
  watch: {
    cardno: function (cardno) {
      this.num = 1;
      this.cardList = [];
      this.loaded_all = false;
      if (cardno == "") {
        this.getList({ pageNo: this.num, pageSize: 10 });
      } else {
        this.getList({ pageNo: this.num, pageSize: 10, keyWord: cardno });
      }
    },
  },
  mounted () {
    this.getList({
      pageNo: this.num,
      pageSize: 10,
      // userId: window.localStorage.getItem("userId"),
    });
  },
  methods: {
    handleDialogVisible (visible) {
      this.visible = visible;
    },
    handleControlNumber: digitUtil,
    getList (cardForm) {
      getCardList({
        ...cardForm,
        deviceType: 4,
      }).then((res) => {
        if (res.data != "") {
          if (res.message.code == 0) {
            this.total = res.data.total;
            this.pages = res.data.pages;
            res.data.records.forEach((item) => {
              this.cardList.push(item);
            });
            if (res.data.pages == this.num) {
              Toast("已加载全部数据");
              this.loaded_all = true;
            }
          }
        } else {
          this.cardList = [];
          Toast("暂无数据");
        }
      });
    },
    refresh () {
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
      setTimeout(() => {
        this.refreshing = false;
        this.num = 1;
        this.cardList = [];
        this.getList({ pageNo: this.num, pageSize: 10 });
      }, 1000);
    },
    load () {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.num += 1;
        if (this.num <= this.pages) {
          this.getList({
            pageNo: this.num,
            pageSize: 10,
          });
        }
      }, 2000);
    },
    lossCard (cardNo, state) {
      if (state == "挂失") {
        Toast("当前卡片已挂失");
        return;
      }
      this.cardNo = cardNo
      this.handleDialogVisible(true)
    },
    handleClickLoss () {
      console.log("go handleClickLoss");
      lossCard({ cardNo: this.cardNo }).then((res) => {
        if (res.message.code == 0) {
          Toast("挂失成功");
          this.num = 1;
          this.cardList = [];
          this.loaded_all = false;
          this.visible = false;
          this.getList({ pageNo: this.num, pageSize: 10 });
        } else {
          Toast(res.message.message);
        }
      });
    },
    handleGoToList (id, type) {
      this.$router.push({
        path: `/admin/cardinvest/${id}?type=${type}`
      });
    },
    getRechargeRecods (cardid) {
      this.$router.push({
        path: "/admin/cardinvest/" + cardid,
      });
    },
    getUseRecods (cardid) {
      this.$router.push({
        path: "/admin/carduse/" + cardid,
      });
    },
    addCard () {
      this.$router.push({
        path: "/admin/addCard",
      });
    },
    editCard (item) {
      if (item.state === "挂失") {
        Toast("当前卡片已挂失");
        return;
      }
      this.$router.push({
        path: "/admin/addCard",
        query: item,
      });
    },
    delCard(item){
      this.cardNo = item.cardNo
      this.deleteVisible = true;
    },
    delCardConfirm(){
      delCards({ cardNos: this.cardNo }).then((res) => {
        if (res.message.code == 0) {
          Toast("删除成功");
          this.num = 1;
          this.cardList = [];
          this.loaded_all = false;
          this.deleteVisible = false;
          this.getList({ pageNo: this.num, pageSize: 10 });
        } else {
          Toast(res.message.message);
        }
      });
    },
    chongzhi(item){
      this.curItem = item;
      this.cardNo = item.cardNo
      this.amount = '';
      this.payVisible = true;
    },
    chongzhiConfirm(){
      if (!this.amount) {
        Toast("请输入充值金额");
        return;
      }

      chongzhiCard({ cardNo: this.cardNo, sum: this.curItem.sum, amount:this.amount }).then((res) => {
        if (res.message.code == 0) {
          Toast("充值成功");
          this.num = 1;
          this.cardList = [];
          this.loaded_all = false;
          this.payVisible = false;
          this.getList({ pageNo: this.num, pageSize: 10 });
        } else {
          Toast(res.message.message);
        }
      });
    },
    cancelLoss(item){
      this.curItem = item;
      this.cardNo = item.cardNo
      this.lossVisible = true;
    },
    cancelLossConfirm(){
      cancelLoss({ cardNo: this.cardNo }).then((res) => {
          if (res.message.code == 0) {
            Toast("操作成功");
            this.num = 1;
            this.cardList = [];
            this.loaded_all = false;
            this.lossVisible = false;
            this.getList({ pageNo: this.num, pageSize: 10 });
          } else {
            Toast(res.message.message);
          }
        });
    },
    replaceCardHandler(item){
      this.curItem = item;
      this.cardNo = item.cardNo;
      this.newCardNo = '';
      this.replaceVisible = true;
    },
    replaceCardConfirm(){
      if (!this.newCardNo) {
        Toast("请输入卡号(ABCDEF)+数字(0-9)");
        return;
      }

      var format = /^[a-fA-F0-9]{1,16}$/;
      if (!format.test(this.newCardNo)) {
        Toast("请输入卡号(ABCDEF)+数字(0-9)");
        return;
      } 

      if (this.newCardNo.length !== 16) {
        Toast("请输入16位数卡号");
        return;
      } 

      cardFeplacement({ cardNo: this.cardNo, newCardNo:this.newCardNo, sum:this.sum }).then((res) => {
          if (res.message.code == 0) {
            Toast("操作成功");
            this.num = 1;
            this.cardList = [];
            this.loaded_all = false;
            this.replaceVisible = false;
            this.getList({ pageNo: this.num, pageSize: 10 });
          } else {
            Toast(res.message.message);
          }
        });
    }


  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.cardMain {
  min-height: calc(100vh - 1.8rem);
  background-color: #F5F5F6;


  .content {
    padding: 0 $divPadding;

    .content-title {
      padding: 0.3rem 0;
      color: #666666;
      font-size: $fontSize_14;
      position: relative;

      .el-icon-plus {
        position: absolute;
        right: 0;
        top: 0.4054rem;
        font-weight: bold;
      }
    }

    span {
      color: #3D3D3D;
      margin-left: 0.1rem;
      font-weight: bold;
    }

    .list-item {
      margin-bottom: 0.3rem;
      border-radius: $borderRadius;
      background-color: white;
      padding: $divPadding;

      .header-info {
        display: flex;
        justify-content: space-between;
        padding-bottom: 0.3rem;
        border-bottom: 1px solid #ECECEC;

        .no {
          flex: 1;
          align-self: center;
          color: #444444;
          font-size: $fontSize_14;
          padding-right: 0.3rem;
        }

        .state {
          align-self: center;
          font-size: $fontSize_12;
          color: #DA3D3D;
        }

        .finish {
          color: #3EB03C;
        }

      }

      .data-box {
        margin-top: 0.3rem;
        margin-bottom: 0.2rem;


        .data-item {
          display: flex;
          justify-content: space-between;
          padding: 0.1rem 0;
          font-size: $fontSize_12;

          .before {
            color: #999999;
          }

          .after {
            color: #444444;

          }
        }
      }

      .options-disiabled {
        justify-content: flex-end !important;

        .options-item {
          margin-right: 0.31rem;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      .options {
        padding-top: 0.3267rem;
        border-top: 1px solid #ECECEC;
        display: flex;
        justify-content: flex-end;
        position: relative;

        .options-item {
          border: 1px solid #8697D9;
          font-size: $fontSize_12;
          padding: 0.1rem 0.4rem;
          border-radius: 0.5rem;
          color: #8697D9;
          text-align: center;
          margin-right: 0.31rem;

          &:last-child {
            margin-right: 0;
          }
        }

        .disiabled {
          border-color: #D2D3D7;
          color: #D2D3D7;
        }
      }
    }
  }

  .dialog-content {
    padding: 0.3rem 0;

    .title {
      text-align: center;
      font-size: 0.3783rem;
      color: #3D3D3D;
      font-weight: bold;
      padding: 0.3rem;
    }

    .content-box {
      text-align: center;

      .desc {
        color: #666666;
        font-size: 0.3243rem;
      }

      .confirm {
        width: 5.5135rem;
        border-radius: 1rem;
        padding: 0.2rem;
        margin: 0 auto;
        background-color: #4664DF;
        color: white;
        font-size: 0.3243rem;
        margin-top: 0.6rem;
      }

      .text {
        padding: 0.3rem;
        margin-top: 0.3rem;
        font-size: 0.3243rem;
        color: #888888;
      }
    }
  }

  .info-box-length {
    margin: 0.2778rem 0.3467rem;
    font-size: 0.3733rem;
    color: #000000;
  }

  .collapseBox {
    .card-box {
      margin-bottom: 0.2367rem;
      background: #ffffff;
      border-radius: 0.1867rem;
      padding: 0.32rem;

      .card-title {
        padding-bottom: 0.1667rem;
        border-bottom: 1px solid #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
          font-size: 0.4267rem;
          font-weight: 600;
          color: #000000;
        }

        .status {
          font-size: 0.32rem;
          color: #4373d3;
        }
      }

      .card-center-box {
        margin-top: 0.2333rem;

        .center-info {
          font-size: 0.32rem;
          color: #666666;
          line-height: 0.5867rem;
        }
      }

      .card-buttons {
        margin-top: 0.2667rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        span {
          margin: 0 0.2rem;
          width: 1.8933rem;
          height: 0.7467rem;
          text-align: center;
          line-height: 0.7467rem;
          border: 1px solid #134fc5;
          border-radius: 0.3467rem;
          font-size: 0.32rem;
          color: #3961b2;
        }
      }
    }
  }
}

.more {
  position: absolute;
  left: 0.3rem;

  .icon {
    width: 0.4783rem;
    height: 0.4810rem;
  }
}

.dialog-item{
    display: flex;
    margin: 0px 10px 15px 10px;
    text-align: center;
    align-items: center;

    .item-title{
      width: 80px;
    }

}

</style>


<style lang="scss">
@import "@/assets/sass/state.scss";
.site-custom{
     min-width: 120px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
}

.popper__arrow {
  border-bottom-color: white !important;

  &:after {
    border-bottom-color: white !important;
  }
}

.tips-box {
  font-size: $fontSize_12;
  color: #888888;

  div {
    padding: 0.3rem 1rem;
    border-bottom: 1px solid #f7f7f7;
  }

  div:first-child {
    padding-top: 0.1rem;
  }

  div:last-child {
    padding-bottom: 0.1rem;
    border-bottom: 0px solid #f7f7f7;
  }
}

.options{
  min-height: 30px;
}

</style>
